import React, { useState } from 'react';

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleIndex = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
  {
    question: "Can I edit my generated document?",
    answer:
      "Yes! Zynth.ai gives you three powerful ways to edit and shape your documents:\n" +
      "• Quick Generate – Get fast AI drafts in seconds.\n" +
      "• Section Narrative – Build documents with logical, flowing sections.\n" +
      "• Custom Builder – Full control over structure, tone, and style for professional results.",
  },
  {
    question: "Why use Zynth.ai AI Document Builder instead of ChatGPT?",
    answer:
      "While ChatGPT is a general-purpose AI, Zynth.ai is a specialized AI document generator. It goes beyond just writing text by offering:\n" +
      "• Structured document generation (reports, proposals, essays, compliance docs).\n" +
      "• Section-wise creation (Quick Generate, Section Narrative, Custom Builder).\n" +
      "• Built-in formatting tools (tables, charts, images, team profiles).\n" +
      "• Direct DOCX and PDF exports with formatting preserved.",
  },
  {
    question: "Is there a free trial for Zynth.ai?",
    answer:
      "Yes! Your first 3 document generations are completely free. You can try out Quick Generate, Section Narrative, and Custom Builder without any cost before upgrading.",
  },
  {
    question: "Does Zynth.ai support AI images?",
    answer:
      "Yes. You can generate AI images, and charts/infographics can be auto-generated from data with our AI report writer.",
  },
  {
    question: "Can I collaborate with my team inside Zynth.ai?",
    answer:
      "Yes! Zynth.ai supports team collaboration so you can build documents together in real time. It also allows role-based access.",
  },
];


    return (
        <section className="py-16 px-0  sm:px-8 max-w-[100%] sm:max-w-[88%] mx-5 sm:mx-14">
      <h2 className="text-center text-4xl font-bold text-gray-900 mb-10">
        Frequently Asked <span className="text-[#3667B2]">Questions!</span>
      </h2>

      <div className="divide-y divide-gray-300">
        {faqItems.map((item, index) => (
          <div key={index} className="py-4">
            <button
            
              type="submit"
              onClick={() => toggleIndex(index)}
              className="w-full text-left font-semibold text-lg flex justify-between items-center cursor-pointer focus:outline-none"
              aria-expanded={openIndex === index}
              aria-controls={`faq-${index}-content`}
              id={`faq-${index}-header`}
            >
              {item.question}
              <span className="text-xl">{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && (
              <div
                id={`faq-${index}-content`}
                aria-labelledby={`faq-${index}-header`}
                className="mt-2 text-gray-600 leading-relaxed max-w-[600px]"
              >
                {item.answer.split('\n').map((line, lineIndex) => (
                  <p key={lineIndex} className={lineIndex > 0 ? 'mt-1' : ''}>
                    {line}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
    );
};

export default FaqSection;